const prefix = 'g8-iframe/v1';

export const TOGGLE_FRAME = `${prefix}/TOGGLE_FRAME`;
export const FRAME_READY = `${prefix}/FRAME_READY`;
export const PROFILE_DATA = `${prefix}/PROFILE_DATA`;
export const VIDEO_COMPLETED = `${prefix}/VIDEO_COMPLETED`;
